import { render, staticRenderFns } from "./AxTabPanel.vue?vue&type=template&id=1ddfebfe&scoped=true"
import script from "./AxTabPanel.vue?vue&type=script&lang=ts"
export * from "./AxTabPanel.vue?vue&type=script&lang=ts"
import style0 from "./AxTabPanel.vue?vue&type=style&index=0&id=1ddfebfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddfebfe",
  null
  
)

export default component.exports